<template>
  <div style="min-height: 750px;">
    <b-card no-body :class="[d_fullScreen ? 'full-screen-mode' : 'normal-mode']">
      <b-row :style="d_fullScreen ? 'position: fixed; top: 0; left: 0; width: 100%; height: 50px; z-index: 1001; background-color: white; border-bottom: solid 1px #a5aaad; box-shadow: 1px 1px 1px 0px; margin: 0px;' : ''">
        <b-col sm="12" lg="11">
            {{ StoreLangTranslation.data['user_shop_bundle_list'][StoreLang]  }}
        </b-col>
        <b-col sm="12" lg="1">
          <b-button class="pull-right" size="lg" variant="white" @click="d_fullScreen ? d_fullScreen = false : d_fullScreen = true">
            <i class="fa fa-desktop"></i>
          </b-button>
        </b-col>
      </b-row>  
      <b-row :style="d_fullScreen ? 'margin-top: 50px;' : 'margin: 0px;'">
        <b-col sm="12" lg="12">
          <shop-bundle-manage :d_userShopClientID="d_userShopClientID"></shop-bundle-manage>
        </b-col>
      </b-row>
    </b-card>  
  </div>
</template>

<script>

import { ClsUser } from '@/wam/modules/user';
import { ClsWdm } from '@/wam/modules/wdm';
import { ClsRoute } from '@/wam/modules/route';
import store from '@/store';
import { ServiceFunctions } from '@/wam/modules/service';
import {
  default as AgreementView
} from '@/wam/components/widgets/AgreementView';
import {
  default as ShopBundleManage
} from '@/wam/components/shop/ShopBundleManage';
import { mapGetters } from 'vuex';
export default {
  name: 'user_shop_bundle_manage',
  computed: mapGetters({
    StoreDevice: 'StoreDevice',
    StoreLang: 'StoreLang',
    StoreLangList: 'StoreLangList',
    StoreLangTranslation: 'StoreLangTranslation',
    StoreFrontendSettings: 'StoreFrontendSettings',
  }),
  components: {
    AgreementView,
    ShopBundleManage,
  },
  props: {
  },
  data () {
    return {
      d_fullScreen: true,
      d_agreementModal: {
        'show': false,
        'shop_data': {},
        'bundle_data': {},
      },
      d_user: '',
      d_hoverIndex: '',
      d_searchText: '',
      d_frontendClientID: '',
      d_frontendList: [],
      d_usrShpBundleList: [],
      d_usrShpBundWdm: '',
      ClsUser: ClsUser,
    };
  },
  created: function () {
    ClsWdm.getLayerWdm('usr_shp_bund').then(resp_wdm_data => { this.d_usrShpBundWdm = resp_wdm_data; });
    this.d_user = JSON.parse(localStorage.getItem('user'));
    this.d_userShopClientID = this.$route.query.user_shop_client_id;

    let auth_eligible = false;
    let user_perm_eligible = false;
    let user_perm_eligibleGeneral = false;
    if (this.$route.meta && this.$route.meta.permission && this.$route.meta.permission.length > 0) {
      auth_eligible = ClsUser.f_checkUserAuth(this.$route.meta.permission, 'without_id');
      if (auth_eligible) {
        user_perm_eligible = ClsUser.f_checkUserAuth([this.d_userShopClientID + '_shop_admin', this.d_userShopClientID + '_shop_bundle_add_edit'],'with_id');
        user_perm_eligibleGeneral = ClsUser.f_checkUserAuth(['admin', 'shop_admin', 'shop_bundle_add_edit']);
      }
    }
    if (this.d_user && this.d_user.username && auth_eligible && (user_perm_eligible || user_perm_eligibleGeneral) ) {
      this.f_userShopBundleList();
    } else {
      this.$router.push({ path: this.StoreLangTranslation.data['page_404_path'][this.StoreLang], query: {} });
    }
  },
  beforeMount () {},
  mounted: function () {
    // console.log(this.StoreFrontendSettings);
    // console.log(this.d_usrShpBundWdm);
  },
  methods: {
    f_agrementView: function (user_shop_bundle_client_id) {
      this.d_agreementModal.shop_data = {'client_id': this.d_userShopClientID };
      this.d_agreementModal.bundle_data = {'client_id': user_shop_bundle_client_id, 'agreement_client_id': '' };
      this.d_agreementModal.show = true;
    },
    f_newUserShopBundle: function () {
      this.$router.push({ path: ClsRoute.f_getRoutePath('user_shop_bundle_record', this.StoreLang), query: {'user_shop_client_id': this.d_userShopClientID} });
    },
    f_goToUserShopBundleProductListPage: function (user_shop_bundle_client_id) {
      this.$router.push({ path: ClsRoute.f_getRoutePath('user_shop_bundle_product_list', this.StoreLang), query: {'user_shop_client_id': this.d_userShopClientID, 'user_shop_bundle_client_id': user_shop_bundle_client_id} });
    },
    f_goToUserShopBundleDiscountListPage: function (user_shop_bundle_client_id) {
      this.$router.push({ path: ClsRoute.f_getRoutePath('user_shop_bundle_discount_list', this.StoreLang), query: {'user_shop_client_id': this.d_userShopClientID, 'user_shop_bundle_client_id': user_shop_bundle_client_id} });
    },
    f_goToUserShopBundleAgreementListPage: function (user_shop_bundle_client_id) {
      this.$router.push({ path: ClsRoute.f_getRoutePath('user_shop_bundle_agreement_list', this.StoreLang), query: {'user_shop_client_id': this.d_userShopClientID, 'user_shop_bundle_client_id': user_shop_bundle_client_id} });
    },
    f_editThisUserShopBundle: function (user_shop_bundle_client_id) {
      let route_path = ClsRoute.f_getRoutePath('user_shop_bundle_record', this.StoreLang);
      // console.log('route_path : ', route_path);
      this.$router.push({ path: route_path, query: { 'user_shop_bundle_client_id': user_shop_bundle_client_id, 'user_shop_client_id': this.d_userShopClientID } });
    },
    f_searchUserShopBundle: function (usr_shp_bund) {
      let res = false;
      if (this.d_searchText) {
        if (usr_shp_bund.w_id.toLocaleLowerCase().indexOf(this.d_searchText.toLocaleLowerCase()) !== -1) {
          res = true;
        }
      } else {
        res = true;
      }
      return res;
    },
    f_userShopBundleList: function () {
      let query = 'user_client_id=' + this.d_user.username;
      query += '&user_shop_client_id=' + this.d_userShopClientID;
      let data = {};
      ServiceFunctions.user_shop_bundle_list(query, data)
        .then(resp => {
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            if (resp.data.list) {
              this.d_usrShpBundleList = resp.data.list;
            } else {
              alert(this.StoreLangTranslation.data['process_completed'][this.StoreLang]);
            }
          } else {
            alert(resp.data.status_code + ' = ' + resp.data.status_message);
          }
        });
    },
  },
  watch: {
  }
};

</script>

